/* OSCO · Registro de solicitudes web (assets/osco-registro.js)
   Copia cada formulario de contacto de Shopify (cotización, contacto, buzón) a la hoja de registro.
   No cambia nada de lo que ve el cliente: el formulario se sigue enviando igual a ventas@. */
(function () {
  var URL_REGISTRO = 'https://script.google.com/macros/s/AKfycbxBXF50areXZNS0FRRSe2i-MhJyT0ePwznnny92QksxTthNtKNJWtOC_D_L1TrMy-QddA/exec';
  var CLAVE = 'osco-web-2026';
  if (window.__oscoRegistro || URL_REGISTRO.indexOf('https://') !== 0) return;
  window.__oscoRegistro = true;

  /* ---- Origen: de dónde llegó la persona (Google, Maps, Instagram, ChatGPT...). Se guarda 30 días. ---- */
  function leerOrigen() {
    try { var o = JSON.parse(localStorage.getItem('osco_origen') || 'null'); if (o && Date.now() - o.t < 2592000000) return o.v; } catch (e) {}
    return '';
  }
  function calcularOrigen() {
    var p = new URLSearchParams(location.search), src = (p.get('utm_source') || '').toLowerCase(), med = (p.get('utm_medium') || '').toLowerCase(), camp = p.get('utm_campaign') || '';
    if (p.get('gclid') || p.get('gbraid') || p.get('wbraid')) return 'Google Ads';
    if (src) {
      if (src === 'google' && med === 'maps') return 'Google Maps' + (camp ? ' (' + camp + ')' : '');
      if (src === 'google' && /cpc|ads|paid/.test(med)) return 'Google Ads' + (camp ? ' (' + camp + ')' : '');
      return src.charAt(0).toUpperCase() + src.slice(1) + (med ? ' / ' + med : '') + (camp ? ' (' + camp + ')' : '');
    }
    var r = document.referrer, h = '';
    try { h = r ? new URL(r).hostname.replace(/^www\./, '') : ''; } catch (e) {}
    if (!h || h.indexOf('oscodominicana.com') > -1 || h.indexOf('myshopify.com') > -1) return '';
    if (/google\./.test(h)) return 'Google (búsqueda)';
    if (/bing\.com/.test(h)) return 'Bing';
    if (/chatgpt\.com|openai\.com/.test(h)) return 'ChatGPT';
    if (/perplexity/.test(h)) return 'Perplexity';
    if (/gemini\.google|copilot|bard/.test(h)) return 'IA (' + h + ')';
    if (/instagram/.test(h)) return 'Instagram';
    if (/facebook|fb\.com|l\.facebook/.test(h)) return 'Facebook';
    if (/linkedin|lnkd\.in/.test(h)) return 'LinkedIn';
    if (/whatsapp|wa\.me/.test(h)) return 'WhatsApp';
    if (/youtube/.test(h)) return 'YouTube';
    if (/tiktok/.test(h)) return 'TikTok';
    if (/mail|outlook|mailchimp|list-manage/.test(h)) return 'Correo';
    return 'Otro sitio (' + h + ')';
  }
  try {
    var nuevo = calcularOrigen();
    if (nuevo) localStorage.setItem('osco_origen', JSON.stringify({ v: nuevo, t: Date.now() }));
  } catch (e) {}
  function origen() { return leerOrigen() || 'Directo'; }

  /* ---- Google Analytics: eventos de lo que importa ---- */
  function ga(evento, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', evento, params || {}); } catch (e) {}
  }
  var ASESORAS = { '18498598574': 'Los Prados', '18498598576': 'Alma Rosa', '18498598573': 'Los Alcarrizos' };
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a, button') : null;
    if (!a) return;
    var href = (a.getAttribute('href') || '').toLowerCase();
    if (/wa\.me|whatsapp\.com/.test(href)) {
      var num = (href.match(/(\d{10,13})/) || [])[1] || '';
      ga('whatsapp_click', { almacen: ASESORAS[num] || 'General', numero: num, pagina: location.pathname });
    } else if (href.indexOf('tel:') === 0) {
      ga('phone_click', { numero: href.replace('tel:', ''), pagina: location.pathname });
    } else if (href.indexOf('mailto:') === 0) {
      ga('email_click', { pagina: location.pathname });
    } else if (a.matches && (a.matches('[name="add"], .ocal-cta a, [data-add-to-cart], button[type="submit"][name="add"]') || /agregar a mi cotizaci/i.test(a.textContent || ''))) {
      ga('add_to_quote', { pagina: location.pathname });
    }
  }, true);

  function esContacto(f) {
    return f && f.querySelector && f.querySelector('input[name="form_type"][value="contact"]');
  }

  function enviar(f) {
    if (!esContacto(f)) return;
    var ahora = Date.now();
    if (f.__oscoT && ahora - f.__oscoT < 8000) return;   // evita duplicados del mismo envío
    var campos = {}, tieneContacto = false;
    try {
      new FormData(f).forEach(function (v, k) {
        if (typeof v !== 'string') return;
        if (/^(form_type|utf8|authenticity_token|g-recaptcha|h-captcha|cf-turnstile|return_to)/i.test(k)) return;
        campos[k] = campos[k] ? campos[k] + ', ' + v : v;
        if (/email|correo|phone|telefono|tel[eé]fono/i.test(k) && v.trim()) tieneContacto = true;
      });
    } catch (e) { return; }
    if (!tieneContacto) return;                           // formulario incompleto: no se anota
    f.__oscoT = ahora;
    campos['Origen'] = origen();
    var tipoTxt = Object.keys(campos).map(function (k) { return k + ' ' + campos[k]; }).join(' ');
    var esCotiz = /cotiz/i.test(tipoTxt);
    var alm = '';
    Object.keys(campos).forEach(function (k) { if (/almac/i.test(k)) alm = campos[k]; });
    var tot = (tipoTxt.match(/TOTAL DE REFERENCIA[^:]*:\s*RD\$\s*([\d,]+(?:\.\d+)?)/i) || [])[1];
    if (esCotiz) ga('generate_lead', { currency: 'DOP', value: tot ? parseFloat(tot.replace(/,/g, '')) : 0, almacen: alm, origen: campos['Origen'] });
    else if (/buz[oó]n|mejora|expectativa/i.test(tipoTxt + ' ' + location.pathname)) ga('buzon_submit', { almacen: alm });
    else ga('contact_submit', { almacen: alm, origen: campos['Origen'] });
    var datos = JSON.stringify({ k: CLAVE, pagina: location.pathname, campos: campos });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(URL_REGISTRO, new Blob([datos], { type: 'text/plain;charset=utf-8' }))) return;
    } catch (e) {}
    try {
      fetch(URL_REGISTRO, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: datos });
    } catch (e) {}
  }

  document.addEventListener('submit', function (e) { if (e.defaultPrevented) return; enviar(e.target); }, false);   // si otro script frena el envío para completar el mensaje (cotización), se anota cuando lo reenvía con form.submit()
  var original = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () { enviar(this); return original.apply(this, arguments); };

  /* ---- Almacén: que arranque vacío y sea obligatorio (para que cada cotización le llegue a la asesora correcta) ---- */
  function esCampoAlmacen(el) {
    if (/almac/i.test(el.name || '') || /almac/i.test(el.id || '')) return true;
    var t = el.tagName === 'SELECT' ? el.textContent : '';
    return /prados/i.test(t) && /alma\s*rosa/i.test(t);
  }
  function prepararAlmacen() {
    var forms = document.querySelectorAll('form');
    Array.prototype.forEach.call(forms, function (f) {
      if (!esContacto(f)) return;
      // Lista desplegable
      Array.prototype.forEach.call(f.querySelectorAll('select'), function (s) {
        if (s.__oscoAlm || !esCampoAlmacen(s)) return;
        s.__oscoAlm = true;
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = 'Elige el almacén donde retirarás';
        ph.disabled = true;
        s.insertBefore(ph, s.firstChild);
        ph.selected = true;
        s.value = '';
        s.required = true;
      });
      // Botones de opción
      var grupo = Array.prototype.filter.call(f.querySelectorAll('input[type="radio"]'), function (r) { return /almac/i.test(r.name || ''); });
      if (grupo.length && !grupo[0].__oscoAlm) {
        grupo.forEach(function (r) { r.__oscoAlm = true; r.checked = false; r.defaultChecked = false; });
        grupo[0].required = true;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepararAlmacen); else prepararAlmacen();
  document.addEventListener('shopify:section:load', prepararAlmacen);
  try {
    var espera;
    new MutationObserver(function () { clearTimeout(espera); espera = setTimeout(prepararAlmacen, 250); })
      .observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
